export default {
  common: {
    appName: 'Chaild Preschool',
    welcome: 'Welcome',
    login: 'Login',
    logout: 'Logout',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteConfirm: 'Delete?',
    saved: 'Saved',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    date: 'Date',
  },
  auth: {
    signIn: 'Sign In',
    signOut: 'Sign Out',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot Password?',
    rememberMe: 'Remember Me',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    logoutSuccess: 'Logout successful',
  },
  navigation: {
    home: 'Home',
    profile: 'Profile',
    settings: 'Settings',
    notifications: 'Notifications',
    toTodayRecord: 'Go to Today\'s Record',
    toParentsRecord: 'Go to Parents\' Record',
  },
  settings: {
    title: 'Settings',
    language: 'Language',
    theme: 'Theme',
    notifications: 'Notifications',
    privacy: 'Privacy',
    about: 'About',
    eventCalendar: 'Event Calendar',
    switchNursery: 'Switch Nursery',
    notificationSettings: 'Notification Settings',
    logout: 'Logout',
    absentContact: 'Absence Contact',
    pickupChange: 'Pickup Change',
    chat: 'Chat',
    newApplication: 'New Application',
    applicationApproval: 'Application Approval',
    applicationRejection: 'Application Rejection',
    both: 'Both',
    pushOnly: 'Push Only',
    emailOnly: 'Email Only',
    noNotification: 'No Notification',
    currentNursery: 'Current Nursery',
    selectNursery: 'Please select a nursery',
    change: 'Change',
  },
  errors: {
    notFound: 'Page not found',
    serverError: 'Server error',
    networkError: 'Network error',
    unauthorized: 'Unauthorized access',
    forbidden: 'Access forbidden',
    validationError: 'Invalid data',
    E000: 'An unexpected system error occurred. Please try again later or contact customer support.',
    E001: 'The request parameters do not match the API specification.',
    E002: 'Token has expired.',
    E003: 'User does not exist.',
    E004: 'User already exists.',
    E005: 'The specified ObjectType is invalid.',
    E006: 'Breakfast record does not exist.',
    E007: 'Breakfast record already exists.',
    E008: 'Dinner record does not exist.',
    E009: 'Dinner record already exists.',
    E010: 'Defecation record does not exist.',
    E011: 'Milk record does not exist.',
    E012: 'Sleep record does not exist.',
    E013: 'Temperature record does not exist.',
    E014: 'Childcare diary record does not exist.',
    E015: 'Childcare diary record already exists.',
    E016: 'Meal record does not exist.',
    E017: 'Meal record already exists.',
    E018: 'Cannot register due to overlapping absence periods.',
    E019: 'The selected reason is invalid.',
    E020: 'The selected pick-up person is invalid.',
    E021: 'Message not found.',
    E022: 'Pick-up/drop-off data not found.',
    E023: 'Class not found.',
    E024: 'The specified child was not found.',
    E025: 'The specified child is already registered as your family member.',
    E026: 'The specified family was not found.',
    E027: 'User does not belong to the specified family.',
    E028: 'The specified user has already been invited to the specified family.',
    E029: 'The specified format was not found.',
    E030: 'Child ID is not specified.',
    E031: 'The specified feed information does not exist.',
    E032: 'The specified feed detail information does not exist.',
    E033: 'The specified report does not belong to the user.',
    E034: 'Attendance/departure record for the specified date already exists.',
    E035: 'Attendance/departure record does not exist.',
    E036: 'No attendance record for the specified date.',
    E037: 'Attendance record for the specified date already exists.',
    E038: 'Departure record for the specified date already exists.',
    E039: 'The specified attendance/departure record does not belong to this child.',
    E040: 'An invalid nursery was specified.',
    E041: 'Hiragana validation failed. Please contact support.',
    E042: 'The internally used ID is invalid.',
    E043: 'UQID is invalid.',
    E044: 'CheckSum is invalid.',
    E045: 'The specified menu does not exist.',
    E046: 'This operation is only allowed for administrator users.',
    E047: 'The specified class does not belong to the specified nursery.',
    E048: 'A menu of the specified date and type already exists.',
    E049: 'The specified menu does not belong to the specified nursery.',
    E050: 'User does not belong to the specified nursery.',
    E051: 'This operation is only allowed for administrator users.',
    E052: 'Diary approval status is invalid.',
    E053: 'Nursery diary record does not exist.',
    E054: 'This user does not have approval authority.',
    E055: 'The recorder of this nursery diary is not this user.',
    E056: 'This nursery diary is not pending approval.',
    E057: 'Another user with the same authority has already approved.',
    E058: 'The initial state of the diary must be either applied or draft.',
    E059: 'Newsletter record does not exist.',
    E060: 'This user does not belong to the nursery of the specified menu.',
    E061: 'Meal inspection record for the specified menu already exists.',
    E062: 'The specified meal inspection record does not exist.',
    E063: 'The specified annual event does not exist.',
    E064: 'The specified class ID does not belong to the specified nursery.',
    E065: 'The socketId format is invalid. Please contact the system administrator.',
    E066: 'Nap check pattern does not exist.',
    E067: 'Staff members are duplicated.',
    E068: 'The specified staff does not belong to the specified nursery.',
    E069: 'This nap check pattern does not belong to this nursery.',
    E070: 'This child does not belong to this nursery.',
  },
  messages: {
    confirmDelete: 'Are you sure you want to delete?',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
  },
  communication: {
    title: 'Communication',
    chat: 'Chat',
    newMessage: 'New Message',
    newBroadcastMessage: 'New Broadcast Message',
    draft: 'Draft',
    draftList: 'Draft List',
    readySendBox: 'Sent Box',
    readySendBoxTitle: 'Ready to Send Box',
    send: 'Send',
    sending: 'Sending...',
    sent: 'Sent',
    saveToDraft: 'Save to Draft',
    saveToReadySend: 'Save to Ready Send Box',
    savedToDraft: 'Saved to Draft',
    savedToReadySend: 'Saved to Ready Send Box',
    sentSuccess: 'Sent successfully',
    confirm: 'Confirm',
    confirmed: 'Confirmed',
    read: 'Read',
    viewOnly: '※View Only',
    contactEmail: '[Contact Email]',
    goToDraft: 'Go to Draft',
    goToReadySendBox: 'Go to Ready Send Box',
    openDraft: 'Open Draft',
    openReadySendBox: 'Open Ready Send Box',
    createBroadcastMessage: 'Broadcast Message',
    absenceConfirmDelete: 'Confirm/Delete Absence',
    deleteConfirm: 'Delete?',
    deleted: 'Deleted',
    copyText: 'Copy Text',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    showAttachment: 'Show attachment',
    enterComment: 'Enter comment',
    noClassAssigned: 'No class assigned.',
    pdfFallback: 'Cannot display',
    downloadPdf: 'Download PDF',
    // New features
    attendanceList: 'Attendance List',
    noteList: 'Note List',
    absenceList: 'Absence List',
    chatList: 'Chat',
    hamburgerMenu: 'Hamburger Menu',
    deleteAttendanceConfirm: 'Delete Attendance Confirmation',
    attendanceNote: 'Attendance Note',
    draftsList: 'Drafts List',
    readySendBoxList: 'Ready to Send Box',
    createBulkMessage: 'Broadcast Message',
    individualMessages: 'Individual Messages',
    noSavedMessages: 'No saved messages',
    
    // Attendance Summary
    currentChildrenCount: 'Current Children Count',
    absent: 'Absent',
    person: 'person',
    persons: 'persons',
    inChargeClass: 'In Charge Class',
  },
  
  // Diary
  diary: {
    draft: 'Draft',
    applied: 'Applied',
    approved: 'Approved',
    saveDraft: 'Save Draft',
    savedDraft: 'Draft Saved',
    saveAndApply: 'Save & Apply',
    reject: 'Reject',
    approve: 'Approve',
    confirmReject: 'Are you sure you want to reject?',
    willBeRejected: 'It will be returned to the applicant.',
    cancel: 'Cancel',
    chief: 'Chief',
    director: 'Director',
    freeRecord: 'Free Record',
    event: 'Events / Visitors',
    earlyLeaver: 'Early Leavers (Reason)',
    applicant: 'Applicant',
    approverChief: 'Approver (Chief)',
    approverDirector: 'Approver (Director)',
    activity: 'Activity Content',
    handover: 'Handover / Communication',
    remarks: 'Remarks',
    staff: 'Staff',
    approver: 'Approver',
    cancelApproval: 'Cancel Approval (Reject)',
  },
  
  // Comment/Memo
  comment: {
    placeholder: 'Enter comment',
    save: 'Save',
    saved: 'Comment saved',
  },

  absence: {
    listTitle: 'Absence List',
    noAbsences: 'No absences.',
    reason: 'Reason',
    title: 'Absence Registration',
    period: 'Period',
    detail: 'Details',
    comment: 'Comment',
    send: 'Send',
    infection: 'Infectious Disease',
    othersWithComment: 'Others (Comment required)',
    required: 'Required field',
    deleteTitle: 'Delete Absence',
    deleteConfirm: 'Are you sure you want to delete this absence record?',
    delete: 'Delete',
  },

  records: {
    notSharedWithParents: 'The content on this page is not shared with parents.',
    parentsRecordTitle: 'Parents\' Record',
    addRecord: '+ Add Record',
    addRecordTitle: 'Add Record',
    editDeleteRecord: 'Edit/Delete Record',
    sleepTime: 'Sleep Time',
    sleep: 'Sleep',
    temperature: 'Temperature',
    breakfast: 'Breakfast',
    dinner: 'Dinner',
    milk: 'Milk',
    defecation: 'Defecation',
    unknown: 'Unknown',
    noRecord: 'No records',
    classSelection: 'Select Class',
    defaultContent: 'No special notes',
    noClassAssigned: 'No class assigned.',
  },

  attendance: {
    checkedIn: 'Checked In',
    checkedOut: 'Checked Out',
    absent: 'Absent',
    pickupChanged: 'Pickup Changed',
    inCharge: 'In Charge Class',
    attendance: 'Attendance',
  },

  defecation: {
    hard: 'Hard',
    normal: 'Normal',
    soft: 'Soft',
    diarrhea: 'Watery (Diarrhea)',
  },

  absenceReason: {
    fever: 'Fever',
    personal: 'Family Matters',
    infStrep: 'Streptococcal Infection',
    infMycoplasma: 'Mycoplasma Pneumonia',
    infHFMD: 'Hand, Foot and Mouth Disease',
    infSlappedCheek: 'Erythema Infectiosum (Fifth Disease)',
    infStomach: 'Viral Gastroenteritis (Noro, Rota, Adeno, etc.)',
    infHerpangina: 'Herpangina',
    infRS: 'RS Virus Infection',
    infZoster: 'Shingles',
    infRoseola: 'Roseola Infantum',
    infImpetigo: 'Impetigo',
    covid19: 'COVID-19',
    others: 'Others',
  },


  form: {
    recipient: 'Recipient',
    title: 'Title',
    content: 'Content',
    saveToDraft: 'Save to Draft',
    saveToReadyBox: 'Save to Ready Box',
    sendNow: 'Send Now',
    draftLine1: 'Draft',
    draftLine2: 'Save',
    readyLine1: 'Ready Box',
    readyLine2: 'Save',
    sendLine1: 'Send',
    sendLine2: 'Now',
  },

  validation: {
    required: 'This field is required',
    choice2: 'Please select 2 items',
    counter: 'Please enter within 20 characters',
    counter100: 'Please enter within 100 characters',
    counter500: 'Please enter within 500 characters',
    counter1000: 'Please enter within 1000 characters',
    typeNumber: 'Please enter a number',
    email: 'Please enter a valid email address',
    phoneNumber: 'Invalid phone number format',
    postalCode: 'Invalid postal code format',
    integerThan0: 'Please enter an integer greater than or equal to 0',
    multipleSelectRequired: 'This field is required',
  },

  meal: {
    allFinished: 'Mark All Finished',
    stapleFood: 'Staple Food',
    mainDish: 'Main Dish',
    sideDish: 'Side Dish',
    soup: 'Soup',
    dessert: 'Dessert',
    milk: 'Milk',
    snack: 'Snack',
    status: {
      refill: 'Refill',
      finished: 'Finished',
      unfinished: 'Left a little',
      half: 'Ate half',
      little: 'Ate a little',
      notEat: 'Did not eat',
      notServed: 'Not served',
    },
  },

  classDiary: {
    classDiary: 'Class Diary',
    tabRecords: 'Records',
    tabDiary: 'Diary',
    tabMeal: 'Meals',
    diary: 'Diary',
    aim: 'Aim',
    activityMorning: 'Activities (AM)',
    activityAfternoon: 'Activities (PM)',
    evaluation: 'Evaluation & Reflection',
    parentSupport: 'Parent Support',
    applicant: 'Applicant',
    cancelApplication: 'Cancel Application',
    applied: 'Applied',
    apply: 'Apply',
    applicationSubmitted: 'Application submitted',
  },

  others: {
    nurseryDiary: 'Nursery Diary',
    extendedCareDiary: 'Extended Care Diary',
  },
  
  // Tab Bar Navigation
  tabBar: {
    communication: 'Contact',
    record: 'Record',
    other: 'Other',
    settings: 'Settings',
  },
  
  // Date Navigation
  date: {
    previousDay: 'Previous Day',
    nextDay: 'Next Day',
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month',
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    daysOfWeekFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  },
  
  // Filter Dialog
  filter: {
    classFilter: 'Filter by Class',
    fiscalYear: 'School Year',
    noClassesInYear: 'No classes in this school year',
    clear: 'Clear',
    apply: 'Apply',
    yearFormat: 'SY {year}',
  },

  // Temperature Modal
  temperature: {
    beforeCorrection: 'Before correction:',
    averageTemperature: 'Average temperature:',
    timeLabel: 'Time',
    temperatureLabel: 'Temperature',
  },

  // Milk Modal
  milk: {
    beforeCorrection: 'Before correction:',
    timeLabel: 'Time',
    amountLabel: 'Amount',
    milkTypeLabel: 'Milk',
    unknown: 'Unknown',
    breastMilk: 'Breast Milk',
    formulaMilk: 'Formula',
    formulaPowderMilk: 'Formula Milk',
  },

  // Sleep Modal
  sleep: {
    beforeCorrection: 'Before correction:',
    sleepLabel: 'Sleep',
    startTime: 'Start',
    endTime: 'End',
    duration: 'Duration',
  },

  // Defecation Modal
  defecationModal: {
    beforeCorrection: 'Before correction:',
    defecationLabel: 'Defecation',
    timeLabel: 'Time',
    stateLabel: 'Condition',
  },

  memoru: {
    albumListTitle: 'Album List',
    addAlbumButton: '+ Add Album',
    tabAll: 'All',
    tabPublished: 'Published',
    tabUnpublished: 'Unpublished',
    createAlbumTitle: 'Create Album',
    year: 'Year',
    class: 'Class',
    albumTitle: 'Album Title',
    comment: 'Comment',
    publishStartLabel: 'Publish Start *',
    publishNow: 'Publish immediately',
    publishEndLabel: 'Publish End',
    noLimit: 'No limit',
    createAsPrivate: 'Create as private',
    create: 'Create',
  },
  signup: {
    noNurseryFound: 'No nursery school found. Please register your teacher account from the admin panel.',
    goToTop: 'Go to top page',
    logout: 'Logout',
  },

  aiReport: {
    title: 'VEVO Report',
    fiscalYear: 'School Year',
    quarterLabel: 'Quarter {quarter}',
    quarterShort: 'Q{quarter}',
    entry: {
      title: 'VEVO Report',
      description: 'Review and regenerate 3-month development summaries',
    },
    status: {
      published: 'Published',
      draft: 'Draft',
      notGenerated: 'Not created',
    },
    languages: {
      en: 'English',
      ja: 'Japanese',
      ko: 'Korean',
      zh: 'Chinese',
      vi: 'Vietnamese',
      km: 'Khmer',
      hi: 'Hindi',
      ru: 'Russian',
      bn: 'Bengali',
      mn: 'Mongolian',
      tl: 'Tagalog',
      ms: 'Malay',
    },
    top: {
      yearLabel: 'SY {year}',
      totalChildren: '/ {count}',
      empty: 'No reports have been generated for this school year yet. Please run bulk generation from the facility web.',
    },
    quarter: {
      subtitle: 'SY {year} / Quarter {quarter} ({monthsLabel})',
      classChildCount: '{count} children',
      achievedItemCount: 'Achieved items: {count}',
      progressRecordCount: 'Progress records: {count}',
      generationCount: 'Generations: {count}',
      publishedAt: 'Published: {date}',
      noClasses: 'There are no classes for this quarter.',
    },
    detail: {
      subtitle: '{className} / {ageLabel} - SY {year} {monthsLabel}',
      coverageWarning: 'This report was generated using data from {months} only.',
      coverageNone: 'none',
      coverageMonths: 'month(s) {months}',
      contentTitle: 'Report content',
      charCount: '{count} characters',
      notGenerated: 'Not generated yet.',
      publish: 'Publish',
      revertToDraft: 'Revert to draft',
      regenerate: 'Regenerate',
      noDataTooltip: 'Cannot regenerate because there are no development records in this period',
      regeneratingInProgress: 'Regenerating...',
      operationLog: 'Operation log',
      lastGenerated: 'Last generated: {date}',
      lastPublished: 'Last published: {date}',
      publishedNotice: 'Published reports are skipped by bulk regeneration from the facility web. To regenerate, revert to draft first.',
    },
    confirm: {
      publishTitle: 'Publish the report of {name}',
      revertTitle: 'Revert the report of {name} to draft',
      publishMessage: 'A notification will be sent to the parents. Are you sure?',
      revertMessage: 'It will no longer be visible to the parents. Are you sure?',
    },
    regenerateDialog: {
      title: 'Regenerate VEVO Report',
      description: 'The report of {name} will be regenerated.',
      translateNotice: 'The current content will be translated into the selected language and overwritten.',
      asyncNotice: 'This is an asynchronous process and may take from several tens of seconds to a few minutes. The status returns to draft when finished.',
      modeSimple: 'Simple regeneration',
      modeTranslate: 'Translate',
      targetLanguage: 'Target language',
      processing: 'Regenerating...',
      completed: 'Completed.',
      failed: 'Failed.',
      translate: 'Translate',
      start: 'Start',
    },
  },

}
